export enum SignRequestStatus {
  Default,
  ConvertError,
  Converted,
  SendingError,
  Sent,
  Declined,
  Cancelled,
  Expired,
  Signed,
  Viewed,
  Downloaded,
  SignerSigned,
  SignerEmailBounced,
  SignerViewedEmail,
  SignerViewed,
  SignerForwarded,
  SignerDownloaded,
  SignRequestReceived,
  ProcessingError = 100,
}

export const SignRequestStatusName = new Map<number, string>([
  [
    SignRequestStatus.Default,
    $localize`:@@dpr.signRequestStatus.txtPending:Pending`,
  ],
  [
    SignRequestStatus.ConvertError,
    $localize`:@@dpr.signRequestStatus.txtConvertError:Convert error`,
  ],
  [
    SignRequestStatus.Converted,
    $localize`:@@dpr.signRequestStatus.txtConverted:Converted`,
  ],
  [
    SignRequestStatus.SendingError,
    $localize`:@@dpr.signRequestStatus.txtSendingError:Sending error`,
  ],
  [SignRequestStatus.Sent, $localize`:@@dpr.signRequestStatus.txtSent:Sent`],
  [
    SignRequestStatus.Declined,
    $localize`:@@dpr.signRequestStatus.txtDeclined:Declined`,
  ],
  [
    SignRequestStatus.Cancelled,
    $localize`:@@dpr.signRequestStatus.txtCancelled:Cancelled`,
  ],
  [
    SignRequestStatus.Expired,
    $localize`:@@dpr.signRequestStatus.txtExpired:Expired`,
  ],
  [
    SignRequestStatus.Signed,
    $localize`:@@dpr.signRequestStatus.txtSigned:Signed`,
  ],
  [
    SignRequestStatus.Viewed,
    $localize`:@@dpr.signRequestStatus.txtViewed:Viewed`,
  ],
  [
    SignRequestStatus.Downloaded,
    $localize`:@@dpr.signRequestStatus.txtDownloaded:Downloaded`,
  ],
  [
    SignRequestStatus.SignerSigned,
    $localize`:@@dpr.signRequestStatus.txtSigned:Signed`,
  ],
  [
    SignRequestStatus.SignerEmailBounced,
    $localize`:@@dpr.signRequestStatus.txtEmailBounced:Email bounced`,
  ],
  [
    SignRequestStatus.SignerViewedEmail,
    $localize`:@@dpr.signRequestStatus.txtEmailViewed:Email viewed`,
  ],
  [
    SignRequestStatus.SignerViewed,
    $localize`:@@dpr.signRequestStatus.txtViewed:Viewed`,
  ],
  [
    SignRequestStatus.SignerForwarded,
    $localize`:@@dpr.signRequestStatus.txtForwarded:Forwarded`,
  ],
  [
    SignRequestStatus.SignerDownloaded,
    $localize`:@@dpr.signRequestStatus.txtDownloaded:Downloaded`,
  ],
  [
    SignRequestStatus.SignRequestReceived,
    $localize`:@@dpr.signRequestStatus.txtPending:Pending`,
  ],
  [
    SignRequestStatus.ProcessingError,
    $localize`:@@dpr.signRequestStatus.txtProcessingError:Processing error`,
  ],
]);
